// Müşteri portalı KPI kopyası (T19, RK36 tek kaynak) — `KPI_COPY.portal` olarak açılır
// (kpi-ui.ts 600 satır kuralı, TODO-KPI-114/-158: salt taşıma). "AI üretimi"/"AI Kontrolü" burada GEÇMEZ.

import { KPI_BREAKDOWN_COPY } from "./kpi-breakdown-copy";
import { KPI_NOTES_COPY } from "./kpi-notes-copy";
import {} from "./kpi-unit-copy";

/** Müşteri portalı (T19, RK36 tek kaynak). "AI üretimi"/"AI Kontrolü" ifadesi burada GEÇMEZ. */
export const KPI_PORTAL_COPY = {
  tabs: { forms: "Formlarım", kpi: "Performans Göstergeleri", users: "Kullanıcılar" },
  /** Kırılım — "alt kalem" dili, set/grup adı yok (kaynak lib/kpi-breakdown-copy.ts) */
  breakdown: KPI_BREAKDOWN_COPY.portal,
  /** DR9 — KPI_UNIT_CHANGED: hücre editörü içinde amber satır (role=alert) */
  unitChanged: (from: string, to: string, typed: string) =>
    `Bu göstergenin birimi ${from} → ${to} olarak değişti. Girdiğiniz ${typed} kaydedilmedi — değeri ${to} olarak girin.`,
  subTabs: { tablo: "Veri Girişi", ozet: "Özet", import: "İçe Aktar" },
  /** K8 — üst barda çok firmalı kullanıcının firma seçicisi. */
  firmSwitcher: {
    label: "Çalıştığınız şirket",
    hint: "Şirket değiştirince formlar ve göstergeler o şirkete göre yenilenir.",
    logoAlt: (name: string) => `${name} logosu`,
  },
  passiveNote: "Girdikçe kaydedilir, danışmanınız onaylar — ayrıca göndermeniz gerekmez.",
  setLabel: "Veri Seti",
  savedPending: "✓ Kaydedildi · danışman onayında",
  saving: "Kaydediliyor…",
  counter: (s: { open: number; filled: number; awaiting: number; clarification: number }) =>
    `Size açık kategorilerde: ${s.filled} girildi · ${s.awaiting} danışman onayında` +
    (s.clarification ? ` · ${s.clarification} açıklama istendi` : "") +
    ` · ${Math.max(0, s.open - s.filled)} boş`,
  /** M17 — denetçi: veri girişine çağıran "N boş" parçası yok. */
  counterAuditor: (s: { filled: number; awaiting: number; clarification: number }) =>
    `Bu veri setinde: ${s.filled} girildi · ${s.awaiting} danışman onayında` +
    (s.clarification ? ` · ${s.clarification} açıklama istendi` : ""),
  clarificationBand: (n: number) => `Danışmanınız ${n} değer için açıklama istedi:`,
  goToRow: "Satıra git →",
  noAccessTitle: "Danışmanınız henüz erişim tanımlamadı",
  noAccessBody:
    "Performans göstergesi tablonuz açıldığında burada görünecek. Sorularınız için danışmanınıza ya da şirket yöneticinize başvurun.",
  readonlyBand:
    "Bu veri setinde yalnız görüntüleme yetkiniz var — değerleri danışmanınız girer, siz izleyebilirsiniz.",
  /** M17 — denetçide İçe Aktar sekmesi boş durum başlığı. */
  auditorLockTitle: "Denetçi erişimi — içe aktarma kapalı",
  /** M17 — set erişim rolü `auditor` (readonly bandının yerine). */
  auditorBand:
    "Denetçi erişimi — bu veri setini yalnız görüntülersiniz; kanıt dosyalarını indirebilirsiniz, değer giremezsiniz.",
  loadFailed: "Tablo yüklenemedi",
  retry: "Tekrar dene",
  staleTitle: "Bu hücre sunucuda değişti",
  staleBody: "Danışmanınız ya da ekibinizden biri bu değeri sizden sonra güncelledi.",
  staleShow: "Sunucudaki değeri göster",
  verifiedWarn: "Onaylanmış bir değeri değiştirirseniz yeniden onaya gider.",
  /** K6 — önceki yıla göre 10× dışı değer (bloklamaz) */
  outlier: (prior: string, value: string, ratio: string): string =>
    `Önceki yıl ${prior}, bu değer ${value} (${ratio}) — olağan dışı görünüyor, kontrol edin.`,
  // M17: düzenlenebilir kategori yoksa (denetçi / tamamı salt okunur) yalnız görüntüleme sayısı
  footerEditable: (editable: number, readonly: number) =>
    editable === 0
      ? `${readonly} kategori yalnız görüntüleme`
      : `${editable} kategori düzenlenebilir · ${readonly} kategori yalnız görüntüleme`,
  statusCol: "Durum",
  summary: {
    awaiting: (n: number) => `${n} danışman onayında`,
    clarification: (n: number) => `${n} açıklama istendi`,
    corrected: (n: number) => `${n} düzeltildi`,
  },
  status: {
    consultantEntered: "danışman girdi",
    consultantEnters: "danışman girer",
    computed: "hesaplanır",
    inputPending: "girdisi danışman onayında",
    empty: "boş",
  },
  corrected: (from: string | null, to: string, when: string) =>
    from ? `danışman düzeltti ${from} → ${to} · ${when}` : `danışman düzeltti · ${when}`,
  // TODO-KPI-10 — şirket yöneticisi (hücre editörü)
  approveForCompany: "Şirket adına onayla",
  approveForCompanyHint:
    "Şirket yöneticisi olarak bu değeri şirket adına onaylarsınız; danışman onayı yine gerekir.",
  approveForCompanyFailed: "Şirket adına onay kaydedilemedi",
  lockTitle: "Yalnız görüntüleme — değerleri danışmanınız girer",
  derivedClosedInput: "danışman tarafından girilir",
  ozet: {
    strip: (s: { open: number; filled: number; awaiting: number; verified: number }) =>
      `size açık ${s.open} · ${s.filled} girildi · ${s.awaiting} danışman onayında · ${s.verified} onaylandı`,
    tabs: { all: "Tümü", approval: "Danışman onayında", empty: "Boş" },
    panelTitle: "Onay durumu",
    consultant: "Danışmanınız",
    /** TODO-KPI-16 — danışman bilinmiyorsa */
    consultantUnknown: "—",
    lastApproval: "Son onay",
    pendingCount: (n: number) => `${n} değer danışman onayında`,
    noPending: "Danışman onayında değer yok",
    /** "Onay durumu" panelinde sayı etiketi (Finar 17 — eski "Bekleyen") */
    awaitingLabel: "Danışman onayında",
    emptyTitle: "İlk değerinizi girin",
    emptyBody: "Henüz giriş yok — Veri Girişi'nden başlayın.",
    goTable: "Veri Girişi'ne git →",
  },
  import: {
    subtitle: "Excel, PDF veya Word dosyanızdaki performans tablosunu veri setine aktarın.",
    note: "Aktardığınız değerler danışman onayına gider; yeni gösterge ya da işletme eklenmez.",
    entityUnresolved: (names: string[]) =>
      `Eşlenmemiş işletme kolonu: ${names.join(", ")} — bu kolonlar için işletme tanımını danışmanınıza iletin.`,
    forbiddenAction:
      "Bu aktarımda yeni gösterge ya da işletme oluşturulamaz — ilgili satırları atlayın ya da danışmanınıza iletin.",
    forbidden:
      "Bu göstergelere yazma yetkiniz yok — eşleştirmeyi gözden geçirin ya da danışmanınıza iletin.",
  },
  users: { placeholderTitle: "Kullanıcı yönetimi", placeholderHint: "Bu ekran hazırlanıyor." },
  noWorkTitle: "Henüz size açılmış bir çalışma yok",
  noWorkBody: "Şirket yöneticinize başvurun.",
  noFormsBody:
    "Şu anda doldurmanız beklenen bir form bulunmuyor; danışmanınız yeni bir davet oluşturduğunda size e-posta ile haber verilecek.",
  // çok işletmeli müşteri (P1-1): portal tablosu seçili işletmeye daraltılır
  entityLabel: "İşletme",
  entityConsolidated: "Konsolide (yalnız görüntüleme)",
  consolidatedBand:
    "Konsolide görünüm tüm işletmelerin toplamıdır ve yalnız görüntülenir — değer girmek için bir işletme seçin.",
  entityHint: (name: string) => `Girdiğiniz değerler ${name} işletmesine yazılır.`,
  // hücre editörü / geçmiş (P3-16, P3-17)
  replyLabel: "Yanıtınız",
  replyPlaceholder: "Açıklama isteğine kısa yanıt (isteğe bağlı)",
  history: { clarificationNote: "Danışmanınızın açıklama isteği" },
  formulaLabel: "Formül",
  // Dalga 2 K10 — formüllü gösterge salt-okunur; her girişte danışmana not
  formulaReadonly:
    "Formül danışmanınız tarafından belirlenir; bu satır hesaplanır, değiştirilemez.",
  noteLabel: "Danışmanınıza not (isteğe bağlı)",
  noteHint: "Bu hücre için danışmanınıza iletmek istediğiniz bilgi.",
  /** Hücre notu iş parçacığı (müşteri yüzeyi) — Dalga 3 */
  notes: KPI_NOTES_COPY.portal,
  noActiveFormula: "Aktif formül yok — danışmanınız bir varyant seçtiğinde hesaplanır.",
  /** Finar rev-B 3 — formüllü hücre hover kartı (müşteri yüzeyi; kapalı girdi `notes.hiddenInput`) */
  hover: {
    formula: "Formül",
    noFormula: "Aktif formül yok — danışmanınız bir varyant seçtiğinde hesaplanır.",
    more: "Girdiler ve ayrıntı için hücreye tıklayın.",
  },
  /** K8 — kısmi toplam ⓘ penceresi (KPI_COPY.cell ile aynı metin; müşteri yüzeyi) */
  partialInfo: "Kısmi toplam — ayrıntı",
  partialTitle: "Kısmi toplam",
  partialRefs: "Ölçülmeyen kalemler (toplama dahil değil)",
  partialEntities: "Ölçülmeyen işletmeler",
  partialPending: "Bazı girdiler XXX ya da boş",
  allUnmeasuredReason: "tüm kalemler ölçülmüyor",
  /**
   * TODO-KPI-91 — KPI_COPY.cell ile aynı metin (müşteri yüzeyi). Eşleme listesi portalda
   * gösterilmez: kapalı kalem grid'de olmadığından görünür sıra yanıltıcı eşleme verebilir.
   */
  wavgMismatchReason: "alt kalem sayıları eşit değil",
  wavgEmptyReason: "alt kalem yok",
  notificationsHidden: "Bildirimler bu hesapta kapalı",
} as const;
